<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/head_career.jpg')"
      >
      </parallax>
      <div class="container">
        <h3 class="title mt-5">{{ $t('career.pageTitle') }}</h3>
      </div>
    </div>
    <div class="section">
      <div class="container text-left">
        <div class="text-center py-5" v-if="table.data.length == 0">
           <img
              src="img/empty.png"
              alt="No job openings available"
              class="rounded animated fadeInDown"
              style="max-width: 220px;"
            />
            <h3 class="font-weight-bold text-center mt-3" style="color: #008c45;"> {{ $t('career.noOpenings') }}</h3>
        </div>

        <div class="row align-items-stretch" v-else>

          <div class="col-lg-6 mb-4 d-flex" v-for="(row, i) in table.data" :key="i">
            <div class="career-card w-100" @click="openDetail(row)">
              <div class="career-card-top">
                <h4 class="career-card-title">{{ row.position }}</h4>
                <span class="career-level-badge">{{ row.level }}</span>
              </div>
              <p class="career-card-location"><i class="fa fa-location-arrow text-warning mr-2" aria-hidden="true"></i>{{ row.location }}</p>
              <div class="career-card-footer">
                <span class="career-card-date">{{ $t('career.byAdmin') }} · {{ moment(row.created_at).locale($i18n.locale).format('LL') }}</span>
                <span class="career-readmore">{{ $t('career.readMore') }} <i class="fa fa-arrow-right ml-1"></i></span>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DETAIL -->
    <modal :show.sync="form.show" headerClasses="justify-content-center" modal-classes="modal-xl">
      <h6 slot="header" class="title title-up" style="margin-top: 0px;"></h6><hr style="margin-top: -15px;" class="mb-4">
      <h4 class="font-weight-bold text-dark mb-4 text-center">{{ position }}</h4>
      <div class="modal-chip-row">
        <span class="modal-chip"><i class="fa fa-building mr-2"></i>{{ department }}</span>
        <span class="modal-chip"><i class="fa fa-location-arrow mr-2"></i>{{ location }}</span>
        <span class="modal-chip"><i class="fa fa-signal mr-2"></i>{{ level }}</span>
      </div>
      <hr>
      <h5 class="font-weight-bold text-dark">{{ $t('career.modal.jobSummary') }}</h5>
      <div class="modal-text-block">{{ job_description }}</div>

      <h5 class="font-weight-bold text-dark mt-4">{{ $t('career.modal.responsibilities') }}</h5>
      <div class="modal-text-block">{{ responsibilies }}</div>

      <h5 class="font-weight-bold text-dark mt-4">{{ $t('career.modal.requirements') }}</h5>
      <div class="modal-text-block">{{ requirements }}</div>

      <template slot="footer">
        <div class="d-flex justify-content-center w-100">
          <a target="_Blank" :href="`https://system.tef.co.id/proc-pr-rec-form-daftar/${code_position}`">
            <n-button type="default" size="sm" class="btn btn-danger btn-round btn-lg mb-5 px-5 mt-3">
                <span><i class="fa fa-location-arrow text-warning mr-2" aria-hidden="true"></i> {{ $t('career.modal.apply') }}</span>
            </n-button>
          </a>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';
import { Card, Button, FormGroupInput } from '@/components';
import { Modal } from '@/components';
import Api from '@/helpers/api';
var moment = require('moment');
import career from '@/services/career.service';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    Modal,
    [Carousel.name]: Carousel,
    [Button.name]: Button,
    [CarouselItem.name]: CarouselItem
  },
  // methods: {
  //   toDetailProduct(param){
  //     this.$router.push('/detail-product/'+param)
  //   }
  // },
  data () {
    return {
      moment:moment,
      form: {
        add: true,
        title: "",
        show: false
      },
      table: {
        data: []
      },
      search: {
        position: '',
        level: '',
        location: '',
        requirements: '',
        status: '',
      },

      code_position: '',
      position: '',
      department: '',
      location: '',
      level: '',
      job_description: '',
      responsibilies: '',
      requirements: '',

    }
  },
  mounted(){
    this.get();
  },
  methods: {
    openDetail(row){
      this.code_position = row.code;
      this.position = row.position;
      this.department = row.department;
      this.location = row.location;
      this.level = row.level;
      this.job_description = row.job_description;
      this.responsibilies = row.responsibilities;
      this.requirements = row.requirements;
      this.form.show = true;
    },
    get(param){
      let context = this;
      Api(context, career.index({position: this.search.position, level: this.search.level, location: this.search.location})).onSuccess(function(response) {
          context.table.data = response.data.data.data;
      }).onError(function(error) {
          context.table.data = [];
      })
      .call()
    },
  }

};
</script>
<style>
   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }


  .cards{
    box-shadow: 5px 6px 6px 2px #e9ecef;
    transform: scale(1.1);
    cursor: pointer;;
  }

  .career-card {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 16px;
    padding: 26px 28px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .career-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 34px rgba(0, 0, 0, 0.15);
  }

  .career-card-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
  }

  .career-card-title {
    font-weight: 700;
    color: #222;
    margin-bottom: 0;
  }

  .career-level-badge {
    background: #e6f4ec;
    color: #008c45;
    font-weight: 700;
    font-size: 12px;
    padding: 6px 14px;
    border-radius: 20px;
    white-space: nowrap;
  }

  .career-card-location {
    color: #6c757d;
    margin-bottom: 20px;
  }

  .career-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    border-top: 1px solid #eee;
    margin-top: auto;
    font-size: 13px;
  }

  .career-card-date {
    color: #999;
    font-style: italic;
  }

  .career-readmore {
    color: #008c45;
    font-weight: 700;
  }

  .modal-chip-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }

  .modal-chip {
    background: #f4f9f6;
    color: #008c45;
    font-weight: 600;
    font-size: 13px;
    padding: 8px 16px;
    border-radius: 20px;
  }

  .modal-text-block {
    white-space: pre-wrap;
    color: #495057;
    line-height: 1.7;
  }

.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
